import type { BadgeVariant } from '@mnd-frontend/ui';

interface Badge {
  text: string;
  variant: BadgeVariant;
}

export interface Item {
  url: string;
  text: React.ReactNode;
  badge?: Badge;
  newTab?: boolean;
  activeUrl?: string | string[];
  exactMatch?: boolean;
  highlight?: boolean;
}

export interface ItemGroupWithSeparator {
  separator: boolean;
  items: Item[];
}

export interface ItemGroup {
  items: Item[];
}

export interface ItemGroupWithHeading {
  heading: string;
  badge?: Badge;
  items: Item[];
  icon?: React.ReactNode;
}

export enum MenuState {
  Publish = 'publish',
  Contacts = 'contacts',
  MediaRelations = 'mediaRelations',
  Monitor = 'monitor',
  Analyze = 'analyze',
  Reports = 'reports',
  PressroomSelector = 'pressroomSelector',
  Settings = 'settings',
  User = 'user',
  MobileNav = 'mobileNav',
  Trial = 'trial',
  Copilot = 'copilot',
}
